import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import DashboardAllCard from "../../components/DashboardCard/DashboardAllCard";
import TopPropertyDashboard from "../../components/DashboardCard/TopCard";
import { RevenueCard } from "../../components/DashboardCard/RevenueCard";
import { AdminProfit } from "../../components/DashboardCard/AdminProfit";
import Bookings from "../../components/DashboardCard/Bookings";
import { ServiceBasedBookings } from "../../components/DashboardCard/ServiceBasedBookings";
import BlockedList from "../../components/DashboardCard/BlockedList";
import { MMC } from "../../components/DashboardCard/MMC";
import Cancellation from "../../components/DashboardCard/Cancellation";
import { UserWallet } from "../../components/DashboardCard/UserWallet";
import { PropertyRequest } from "../../components/DashboardCard/PropertyRequest";
import Location from "../../components/DashboardCard/Location";
import Properties from "../../components/DashboardCard/Properties";
import Application from "../../components/DashboardCard/Application";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import { checkPermission } from "../redux/api/PermissionManager";

const Dashboard = () => {
  const navigate = useNavigate();
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname, state } = useLocation();
  const path = pathname?.replace("/", "");

  const [isSearch, setIsSearch] = useState("");
  const [isActive, setIsActive] = useState(paginationData?.[path]?.active ?? "Dashboard View");
  const [isData, setIsData] = useState([]);
  const [isDataAllCard, setIsDataAllCard] = useState([]);
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);

  const storePaginationData = (activeTab)=>{
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], active:activeTab},
    }));
  }

  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path]
      ? { ...paginationData?.[path] }
      : {
          from: "",
          to: "",
        },
  );
  const getTopCard = async () => {
    let url = URLS.DASHBOARTOP_CARD;
    const params = [];
    if (selectedFilter.from && selectedFilter.to) {
      params.push(`from_date=${selectedFilter.from}`);
      params.push(`to_date=${selectedFilter.to}`);
    }
    console.log("params", params);

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    let res = await get(url);
    console.log("roles res", res);
    if (res?.status === "success") {
      setIsData(res?.data ?? []);
    }
  };
  const getAllCard = async () => {
    let url = URLS.DASHBOARALL_CARD;
    let res = await get(url);
    console.log("roles res", res);
    if (res?.status === "success") {
      setIsDataAllCard(res?.data || []);
    }
  };

  useEffect(() => {
    getTopCard(); // Only from_date will be sent
  }, [selectedFilter.from && selectedFilter.to]);
  useEffect(() => {
    getAllCard();
  }, []);
  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  console.log("selectedFilter", selectedFilter);

  return !checkPermission("CAN-LIST-DASHBOARD") ? null : (
    <>
      <div style={{ padding: "0px 30px 0px 30px" }}>
        <Topbar
          header={"Dashboard - (CROSS SELL TECHNOLOGIES PRIVATE LIMITED)"}
        />
      </div>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          gap: 10,
          background: "#F4F4F4",
          padding: 20,
        }}
      >
        {["Dashboard View", "Graph View", "Reports"].map((ele) => {
          return (
            <div
              style={{
                cursor: "pointer",
                background: isActive == ele ? "#6B00D8" : "#FFFFFF",

                borderRadius: "8px",
                paddingTop: "7px",
                paddingRight: "15px",
                paddingBottom: "7px",
                paddingLeft: "15px",
              }}
              onClick={() =>{
                storePaginationData(ele)
                setIsActive(ele)}}
            >
              <p
                style={{
                  color: isActive == ele ? "#fff" : "#757575",
                  fontWeight: "500",
                  // fontStyle: "Bold",
                  fontSize: "16px",
                  leadingTrim: "NONE",
                  lineHeight: "150%",
                  letterSpacing: "0px",
                }}
              >
                {ele}
              </p>
            </div>
          );
        })}
      </div>
      {isActive === "Dashboard View" ? (
        <>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              gap: 10,
              background: "#fff",
              // padding: 20,
            }}
          >
            <DashboardAllCard
              setFromDate={(date) => {
                handleChangeFilter("from", date);
              }}
              setToDate={(date) => {
                handleChangeFilter("to", date);
              }}
              isData={isData}
            />
            <TopPropertyDashboard isData={isData} />
          </div>
          {/* Bootom Sheet Cards */}
          <div
            style={{
              background: "#F2F2F2",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "space-between",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                padding: "10px",
                flex: 1,
                minWidth: "300px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ width: "100%" }}>
                <RevenueCard />
              </div>
              <Bookings />
              <BlockedList />
              <Cancellation isDataAllCard={isDataAllCard} />
              <PropertyRequest isDataAllCard={isDataAllCard} />
              <Properties isDataAllCard={isDataAllCard} />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                padding: "10px",
                flex: 1,
                minWidth: "300px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ width: "100%" }}>
                <AdminProfit />
              </div>
              <ServiceBasedBookings isDataAllCard={isDataAllCard} />
              <MMC />
              <UserWallet isDataAllCard={isDataAllCard} />
              <Location isDataAllCard={isDataAllCard} />
              <Application isDataAllCard={isDataAllCard} />
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Dashboard;
